"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenExpired = exports.parseTokenPayload = void 0;
function parseTokenPayload(token) {
    var _a = token.split('.'), payload = _a[1];
    var payloadStr = atob(payload);
    return JSON.parse(payloadStr);
}
exports.parseTokenPayload = parseTokenPayload;
function isTokenExpired(token) {
    if (!token)
        return true;
    var payload = parseTokenPayload(token);
    return payload.exp * 1000 <= Date.now();
}
exports.isTokenExpired = isTokenExpired;
